module.exports = __webpack_public_path__ + "img/review-12.f390298b.jpg";